import { EpStepContent, EpStepTextArea } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

const DescriptionIncidentInput = ({
  translations,
}: {
  translations: string[];
}) => {
  return (
    <EpStepContent.Label
      label={`${t(translations, 'More information about the Incident')} *`}
    >
      <EpStepTextArea
        errorMessage={t(translations, '* Required Fied')}
        maxLength={2000}
        registerId={'descriptionIncident'}
        translations={translations}
      />
    </EpStepContent.Label>
  );
};

export default DescriptionIncidentInput;
